import React from "react"
import {
  TimePicker,
  TimePickerProps,
  TimePrecision,
} from "@blueprintjs/datetime"

export type CustomTimePickerProps = Omit<TimePickerProps, "onChange"> & {
  path?: string
  onChange?: (path: string, value: string) => void
}
const CustomTimePicker = ({
  value,
  onChange,
  path,
  useAmPm = true,
  showArrowButtons = false,
  ...props
}: CustomTimePickerProps) => {
  const parsedValue = value
    ? value instanceof Date
      ? value
      : new Date(value)
    : undefined

  function handleChange(newTime: Date) {
    onChange && onChange(path, newTime.toISOString())
  }

  return (
    <TimePicker
      precision={TimePrecision.MINUTE}
      showArrowButtons={showArrowButtons}
      useAmPm={useAmPm}
      value={parsedValue}
      onChange={handleChange}
      {...props}
    />
  )
}

export default CustomTimePicker
